const errorMap = {
  blank: 'Please enter a value for %n',
};

const getErrorMessage = (err, label) => {
  if (label === 'Audience name') {
    return err.detail;
  }
  return errorMap[err.code] && label && typeof label === 'string'
    ? errorMap[err.code].replace('%n', label)
    : err.detail;
};

export default getErrorMessage;
